import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BarChartLoader, FullPageLoader } from '../../../common/components';
import { ScoreEvaluationStyles } from '../../styles';
import { getCookie } from '../../../common/utils/cookies';
import { WCAGStrandardStyles } from '../../../common/styles/WCAGStandardStyles';

export const ScoreEvaluationPage01 = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { classes } = ScoreEvaluationStyles();
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  const { classes: WCAGClasses } = WCAGStrandardStyles();

  if (tcPlusFlow) return <FullPageLoader isLoading />;

  return (
    <Paper elevation={0} className={classes.container}>
      <Box textAlign="center">
        <Typography role="heading" aria-level={1} className={WCAGClasses.h2}>
          {t('assessmentScoreEvaluationMessage')}
        </Typography>
      </Box>
      <Box mt={4} textAlign="center">
        <BarChartLoader />
      </Box>
    </Paper>
  );
};
